import { Injectable } from '@angular/core';
import {
  ClientQuestionnaireBaseFactory,
} from '../../base-client-questionnaire/form/base-form/client-questionnaire-base.factory';
import {
  MainSpouseQuebec2022TaxQuestionnaireOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/quebec-2022-tax-questionnaire/main-spouse-quebec-2022-tax-questionnaire.options';

import { FormFactory } from "@magieno/angular-advanced-forms";

@Injectable()
export class Quebec2023TaxFormFactory extends ClientQuestionnaireBaseFactory {

  constructor(formFactory: FormFactory) {
    super(formFactory);
    this.optionsType = MainSpouseQuebec2022TaxQuestionnaireOptions;
  }
}
